import { useDisclosure } from '@chakra-ui/react';
import { IQuoteRespSchema, QuoteStatusEnum } from '@monetize/types/app';
import React, { FunctionComponent as FC } from 'react';
import { QuoteProgressStep } from './QuoteProgressStep';

interface QuoteStepEditProps {
  quote: IQuoteRespSchema;
}

export const QuoteStepEdit: FC<QuoteStepEditProps> = React.forwardRef<
  any,
  QuoteStepEditProps
>(({ quote }: QuoteStepEditProps, ref) => {
  let stepTitle = 'Configure Quote Details';
  let stepDate: string | null = null;
  const isCompleted =
    quote.status !== QuoteStatusEnum.DRAFT && !!quote.approvalSubmittedAt;
  const showInprogressStepNumber = false;
  const isDisabled = false;
  const isCurrent = quote.status === QuoteStatusEnum.DRAFT;

  if (isCompleted) {
    stepDate = quote.approvalSubmittedAt;
    stepTitle = 'Quote Details';
  }
  const popoverState = useDisclosure();

  return (
    <QuoteProgressStep
      key="quote-progress-edit"
      stepTitle={stepTitle}
      stepDate={stepDate}
      stepNumber={1}
      isCompleted={isCompleted}
      showInprogressStepNumber={showInprogressStepNumber}
      isDisabled={isDisabled}
      isCurrent={isCurrent}
      containerProps={{ ml: -8 }}
      popoverState={popoverState}
    />
  );
});
